import type { RouteRecordRaw } from "vue-router";

export const authRoutes: RouteRecordRaw[] = [
  { path: "/", name: "home", component: () => import("@/views/HomePage.vue") },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("@/views/SignupPage.vue"),
  },
  {
    path: "/join",
    name: "join",
    component: () => import("@/views/JoinPage.vue"),
  },
  {
    path: "/invite/accept",
    name: "invite-accept",
    component: () => import("@/views/InviteAcceptPage.vue"),
  },
  {
    // Landing page from the bot's manual-link URL in Slack. Reads ?team= and
    // ?user= from the query string and binds the authenticated employee to
    // that Slack identity. If the visitor isn't signed in, redirects to
    // /login with `redirect` set so they bounce back here after sign-in.
    path: "/auth/slack-link",
    name: "slack-link",
    component: () => import("@/views/SlackLinkPage.vue"),
  },
];
